module.exports = __webpack_public_path__ + "img/pic_coin_left.7b7616ad.svg";